<template>
  <sidebar-item :link="{name: $t('Договоры'),  path: `/contract`,  icon: 'vip_icon icon_settings'}">
  </sidebar-item>
</template>
<script>
    export default {
        name: 'ContractMenu',
    }
</script>
